import { ILogger } from '../..';
import ErrorCode from '../../common/error-code';
import RtcError from '../../common/rtc-error';
import { isRotate90Or270 } from '../../utils';
import { Video2dContext, VideoContextErrorCode, VideoGlContext } from '../video-context';
import { VideoNode } from './base';

// const texCoords = [
//   1, 0, // 右下
//   1, 1, // 右上
//   0, 0, // 左下
//   0, 1 // 左上
// ];

const texCoords = [
  1, 0, // 右下
  0, 0, // 左下
  1, 1, // 右上
  0, 1 // 左上
];
export class VideoTransformNode extends VideoNode<TexImageSource, Video2dContext> {
  mirror = false;
  rotation: 0 | 90 | 180 | 270 = 0;
  constructor(context: Video2dContext, logger: ILogger, mirror?: boolean, rotation?: 0 | 90 | 180 | 270) {
    super(context, {
      useDefaultProgram: true,
      useFbo: true,
      create2d: true,
      name: 'transform',
      logger
    });
    if (mirror) this.mirror = mirror;
    if (rotation) this.rotation = rotation;
    if (context instanceof VideoGlContext) {
      try {
        this.setTexBuffer(texCoords);
      } catch (err) {
        context.destroy(new RtcError({
          code: ErrorCode.VIDEO_MANAGER_ERROR,
          extraCode: VideoContextErrorCode.CREATE_VIDEO_NODE_FAILED,
          message: `create video node ${this.name} error ${(err as any).message || err}`
        }));
      }
    }
  }
  draw2d(image: TexImageSource | undefined, dx: number, dy: number, dw: number, dh: number): boolean {
    if (this.ctx2d) {
      this.ctx2d.clearRect(0, 0, this.width, this.height); // 清空变换前的画面
      // Fast path: skip save/scale/translate/rotate/restore when no transform is needed
      if (!this.mirror && this.rotation === 0) {
        return super.draw2d(image, dx, dy, dw, dh);
      }
      this.ctx2d.save();
      if (this.mirror) {
        this.ctx2d.scale(-1, 1);
        this.ctx2d.translate(-this.width, 0);
      }
      if (this.rotation === 90) {
        this.ctx2d.translate(dw, 0);
        this.ctx2d.rotate(Math.PI / 2);
        this.ctx2d.scale(dh / dw, dw / dh);
      } else if (this.rotation === 180) {
        this.ctx2d.translate(this.width, this.height);
        this.ctx2d.rotate(Math.PI);
      } else if (this.rotation === 270) {
        this.ctx2d.translate(0, dh);
        this.ctx2d.rotate(3 * Math.PI / 2);
        this.ctx2d.scale(dh / dw, dw / dh);
      }
      const result = super.draw2d(image, dx, dy, dw, dh);
      this.ctx2d.restore();
      return result;
    }
    return false;
  }
  render(seq: number) {
    if (this.input?.requestFrame(seq)) {
      this.useProgram();
      this.useBufferFrame();
      this.useInputTexture();
      this.draw();
      return true;
    }
    return false;
  }
  resize(width: number, height: number) {
    if (isRotate90Or270(this.rotation)) {
      [width, height] = [height, width];
    }
    super.resize(width, height);
  }
}
